export function blogImages(blog) {
  const gallery = Array.isArray(blog.image_urls) ? blog.image_urls.filter(Boolean) : [];
  return gallery.length ? gallery : blog.image_url ? [blog.image_url] : [];
}
export function blogText(blog, field, language) {
  const primary = language.startsWith('fa') ? 'fa' : 'en';
  return blog[`${field}_${primary}`] || blog[`${field}_${primary === 'fa' ? 'en' : 'fa'}`] || '';
}
export function announceBlogUpdate() {
  window.dispatchEvent(new Event('kavak:blogs-updated'));
  try { localStorage.setItem('kavak:blogs-updated', String(Date.now())); } catch {}
}
export function subscribeBlogUpdates(refresh) {
  const storage = event => { if (event.key === 'kavak:blogs-updated') refresh(); };
  const focus = () => { if (!document.hidden) refresh(); };
  window.addEventListener('kavak:blogs-updated', refresh);
  window.addEventListener('storage', storage);
  window.addEventListener('focus', focus);
  document.addEventListener('visibilitychange', focus);
  const timer = window.setInterval(focus, 60000);
  return () => {
    window.removeEventListener('kavak:blogs-updated', refresh);
    window.removeEventListener('storage', storage);
    window.removeEventListener('focus', focus);
    document.removeEventListener('visibilitychange', focus);
    window.clearInterval(timer);
  };
}

export function blogExcerpt(text) { return (text || "").split(/\n\s*\n/)[0].slice(0, 260); }
